export const GET_APPLICATION_FEEDBACK_STATUS = 'GET_APPLICATION_FEEDBACK_STATUS'
export const SUBMIT_APPLICATION_FEEDBACK = 'SUBMIT_APPLICATION_FEEDBACK'
